import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ProfessionalIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ProfessionalIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.2021 22H2.79766C2.52086 22 2.29688 21.776 2.29688 21.4992C2.29688 21.2224 2.52086 20.9984 2.79766 20.9984H21.2021C21.4789 20.9984 21.7029 21.2224 21.7029 21.4992C21.7029 21.776 21.4789 22 21.2021 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.1666 22H4.27166C3.99485 22 3.77087 21.776 3.77087 21.4992V7.64638C3.77087 7.45956 3.87504 7.28839 4.04083 7.20183L13.9358 2.05654C14.0898 1.97536 14.2771 1.9822 14.4263 2.07317C14.5759 2.16364 14.6674 2.326 14.6674 2.50109V21.4992C14.6674 21.776 14.4434 22 14.1666 22ZM4.77245 20.9984H13.6658V3.32612L4.77245 7.95057V20.9984Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7276 22H14.1867C13.9098 22 13.6859 21.776 13.6859 21.4992V9.62557C13.6859 9.34876 13.9098 9.12478 14.1867 9.12478H19.7276C20.0044 9.12478 20.2284 9.34876 20.2284 9.62557V21.4992C20.2284 21.776 20.0044 22 19.7276 22ZM14.6874 20.9984H19.2268V10.1264H14.6874V20.9984Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.3961 10.4232H7.04262C6.76581 10.4232 6.54183 10.1992 6.54183 9.92242C6.54183 9.64562 6.76581 9.42164 7.04262 9.42164H11.3961C11.6729 9.42164 11.8969 9.64562 11.8969 9.92242C11.8969 10.1992 11.6729 10.4232 11.3961 10.4232Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.3961 13.2925H7.04262C6.76581 13.2925 6.54183 13.0685 6.54183 12.7917C6.54183 12.5149 6.76581 12.2909 7.04262 12.2909H11.3961C11.6729 12.2909 11.8969 12.5149 11.8969 12.7917C11.8969 13.0685 11.6729 13.2925 11.3961 13.2925Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.3961 16.1622H7.04262C6.76581 16.1622 6.54183 15.9382 6.54183 15.6614C6.54183 15.3846 6.76581 15.1606 7.04262 15.1606H11.3961C11.6729 15.1606 11.8969 15.3846 11.8969 15.6614C11.8969 15.9382 11.6729 16.1622 11.3961 16.1622Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.3961 19.0315H7.04262C6.76581 19.0315 6.54183 18.8075 6.54183 18.5307C6.54183 18.2539 6.76581 18.0299 7.04262 18.0299H11.3961C11.6729 18.0299 11.8969 18.2539 11.8969 18.5307C11.8969 18.8075 11.6729 19.0315 11.3961 19.0315Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ProfessionalIcon;
